import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';

import {
  newCheckInAction,
  NEW_CHECKIN,
} from '../../actions/navigation';

import Header from '../../components/Header';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import Modal from '../../components/Modal';
import imgError from '../../assets/images/error.svg';
import { useConfig } from '../../config/ConfigContext';

const Redirection = (props) => {
  const config = useConfig();
  const [isProgressVisible] = useState(true);
  const [uploadingPercentage, setUploadingPercentage] = useState(0);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const { fetch: { isDone, isRunning }, checkinData, navigate } = props;
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');

  const handleRedirect = () => {
    const params = parseUrlParams(window.location.search);
    const isRedirect = get(checkinData, 'data.data.redirect');
    let routeUrl = '';
    if (isRedirect) {
      routeUrl = `/${workflowType === 'dtm-luwa' ? 'luwa' : workflowType}/external-site`;
    } else {
      routeUrl = get(checkinData, 'data.url', '').replace(config.hostUrl, '');
    }
    if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
      routeUrl = addLusaHeaderParam(routeUrl);
    }
    navigate(routeUrl);
  };

  useEffect(() => {
    const params = parseUrlParams(window.location.search);
    if (params.token) {
      props.newCheckInAction({
        rawUrl: `${config.navigationUrl}/${workflowType}/redirection/token/${params.token}`,
      });
    } else {
      if (!params.key) {
        // navigate('/');
      }

      if (isEmpty(checkinData)) {
        props.newCheckInAction({
          workflowType,
          key: params.key,
          onUploadProgress: (progressEvent) => {
            setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
          },
          fail: (error) => {
            setHasError(true);
            setErrorMessage(get(error, 'data.message', 'Internal server error'));
          },
        });
      } else {
        handleRedirect();
      }
    }
  }, []);

  useEffect(() => {
    if (isDone[NEW_CHECKIN] && !isRunning[NEW_CHECKIN]) {
      handleRedirect();
    }
  }, [checkinData]);

  return (
    <Transition className="transition-item wrapper v-center">
      <Header />
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
      {
        hasError && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="error" />
              <p>{errorMessage}</p>
            </div>
          </Modal>
        )
      }
    </Transition>
  );
};

Redirection.propTypes = {
  navigate: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Redirection);
